import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import rawMatIcon from "../../../../../assets/new-product-detail-cats/header-icons/raw-material-icon.svg";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { fetchFlow33AggregatedImpactTotals } from "./flow33ImpactTotals";

const RawMaterialIcon = () => (
  <img src={rawMatIcon} alt="Manufacturing Icon" width={76} height={76} />
);

const RawMaterialHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  totalProdItem,
  ...props
}) => {
  const { t } = useTranslation();
  const [flow33ImpactTotals, setFlow33ImpactTotals] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!productId) {
      setFlow33ImpactTotals(null);
      return undefined;
    }
    fetchFlow33AggregatedImpactTotals(productId).then((totals) => {
      if (!cancelled) setFlow33ImpactTotals(totals);
    });
    return () => {
      cancelled = true;
    };
  }, [productId]);

  return (
    <CategoryComponent
      show={show}
      className={`prod-manufacturing-category ${className || ""}`}
      leftBoxProps={{
        icon: <RawMaterialIcon />,
        title: t("MANUFACTURING_PROCESSES"),
        description: t("MANUFACTURING_PROCESSES_DESC"),
        productId: productId,
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_33") || "Total for Flow 33",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: flow33ImpactTotals,
        lastUpdated: totalProdItem?.updated_at
          ? formatDate(totalProdItem?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default RawMaterialHeader;
